import {API_URL, apiPut} from '../api'
import {IEvent} from './getEventApi'

export const updateEvent = async (id: string, data: IEvent) => {
    return await apiPut(API_URL, `admin/event/${id}`, data)
}
